export default "__VITE_ASSET__Dwifwn_V__"